<template>
    <div class="cont">
        <div class="userInfo">
            <div class="logo">
                <img src="../static/images/loginLogo.jpg" alt="">
                <div>欢迎登录顺聚祥校服订购平台</div>
            </div>
            <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px" class="demo-ruleForm">
                <el-form-item prop="accountNumber" label-width="0">
                    <el-input @focus="resetForm" class="formName" placeholder="请输入账户名" prefix-icon="el-icon-date"
                        v-model.trim="userForm.accountNumber">
                    </el-input>
                </el-form-item>
                <br><br>
                <el-form-item prop="pwd" label-width="0">
                    <el-input @focus="resetForm" class="formName" show-password placeholder="请输入密码"
                        prefix-icon="el-icon-date" v-model="userForm.pwd" @keyup.enter.native="submitForm('userForm')">
                    </el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" class="but" :loading="loading" @click="submitForm('userForm')">登 录</el-button>
        </div>
    </div>
</template>
<script>
import request from '../utils/request';
import App from '../App';
export default {
    data() {
        return {
            // 登录账号
            userForm: {
                accountNumber: "",
                pwd: ""
            },
            // 登录校验
            rules: {
                accountNumber: [
                    { required: true, message: "请输入账号", trigger: "blur" },
                ],
                pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
            },
            loading: false,
            isCheck: false,
            menu: []
        }
    },
    created() {
        // let backlen = window.history.length - 2
        // console.log(backlen, window.history.length, window.history.back);
        // if (backlen > 0) {
        //     window.history.go(-backlen)
        // }
    },
    methods: {
        login() {
            let authorization = sessionStorage.getItem("authorization");
            if (authorization !== null) {
                sessionStorage.removeItem("authorization");
            }
            // console.log(authorization);
            request({
                method: "POST",
                url: "admin/user/login",
                data: this.userForm,
            }).then(res => {
                this.loading = false
                if (res.code === '200') {
                    //console.log(res);
                    this.$store.dispatch('updateUserInfo', res.data)
                    sessionStorage.setItem("authorization", res.data.authorization);
                    // localStorage.setItem(res.data.accountNumber+"authorization", res.data.authorization);
                    this.$store.dispatch('updateMenu', res.data.menuTreeVos)
                    App.methods.addId(res.data.userId)
                    this.$notify({
                        title: res.message,
                        type: 'success'
                    });
                    this.traversalMenu()
                    this.$router.push("/index");
                } else {
                    this.$notify({
                        title: res.message,
                        type: 'error'
                    });
                }
            }).catch(() => {
                this.loading = false
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.login();
                } else {
                    this.isCheck = true
                }
            });
        },
        resetForm() {
            if (this.isCheck) {
                this.$refs['userForm'].resetFields();
                this.isCheck = false
            } else {
                return
            }

        },
        async getMenu() {
            const res = await request({
                url: 'admin/user/login/menu',
                method: 'GET'
            })
            if (res.code === '200') {
                this.menu = res.data
                this.$store.dispatch('updateMenu', res.data)
                this.traversalMenu()
            }
        },
        // 遍历菜单
        traversalMenu() {
            let data = this.$store.state.menu
            data.forEach(item => {
                //console.log(item)

                if (item.menuType === 1) {
                    this.$router.addRoute('Layout', {
                        path: item.url,
                        name: item.url.slice(1),
                        component: () => import('../views' + item.url + '.vue'),
                        meta: {
                            keepAlive: false
                        }
                    })
                    item.child.forEach((v) => {
                        //console.log('v', v);
                        if (v.menuType === 3) {
                            this.$router.addRoute('Layout', {
                                path: v.url,
                                name: v.url.slice(1),
                                component: () => import('../views' + v.url + '.vue'),
                                meta: {
                                    keepAlive: false
                                }
                            })
                        }
                    })
                } else if (item.menuType === 0) {
                    item.child.forEach(val => {
                        //console.log(val);
                        this.$router.addRoute('Layout', {
                            path: val.url,
                            name: val.url.slice(1),
                            component: () => import(`../views${val.url}.vue`),
                            meta: {
                                keepAlive: false
                            }
                        })
                        val.child.forEach((v) => {
                            //console.log('v', v);
                            if (v.menuType === 3) {
                                this.$router.addRoute('Layout', {
                                    path: v.url,
                                    name: v.url.slice(1),
                                    component: () => import('../views' + v.url + '.vue'),
                                    meta: {
                                        keepAlive: false
                                    }
                                })
                            }
                        })
                    })
                }
            });
        }
    },
    mounted() {
        // //console.log(App.methods.beforeunloadHandler());
        // this.$emit('updateUser',2)
    },
}
</script>

<style lang="scss" scoped>
.cont {
    width: 100%;
    height: 100vh;
    background-image: url(../static/images/loginbgc.jpg);
    background-size: 100% 100%;
    position: relative;
    box-sizing: border-box;

}

.userInfo {
    width: 500px;
    height: 600px;
    padding: 40px;
    background-color: #fff;
    position: absolute;
    left: calc(50% - 250px);
    top: calc(50% - 300px);
    border-radius: 30px;
    box-shadow: 10px 10px 20px 10px #A9D3FA;

    .logo {
        text-align: left;
        margin-bottom: 60px;

        div {
            font-size: 30px;
            font-weight: bold;
            padding-left: 30px;
            color: #808080;
        }
    }
}

::v-deep .el-input--prefix .el-input__inner {
    border: 0;
    height: 50px;
    line-height: 50px;
    border-radius: 0;
    padding-left: 50px;
    border-bottom: 1px solid #808080;

    &::placeholder {
        font-size: 16px;
    }
}

.but {
    width: 300px;
    height: 50px;
    font-size: 20px;
    line-height: 20px;
    margin-top: 40px;
    border-radius: 10px;
}
</style>